export default __webpack_public_path__ + "static/kb_2_12-b50dcf5fee03f299e4bdb290f1979900.jpg";